import React, { Component } from 'react';
import { AppBar, Toolbar, Typography, withStyles, Button, Popper, Paper } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/icons/Menu';
import NotificationsNoneRoundedIcon from '@material-ui/icons/NotificationsNoneRounded';
import ThemeVars from '../ThemeVars';
import Nav from './Nav';
import AppContext from '../AppContext';
import { changeLanguage } from '../locales/LocaleService';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    appBar: {
        display: 'flex',
        backgroundColor: ThemeVars.appBarBackground
    },

    appBarRestaurantTitle: {
        flex: 1,
        paddingLeft: theme.spacing.unit * 3
    },

    menuButton: {
        width: 'auto'
    },

    popper: {
        zIndex: 10000
    }
});


class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            menuOpen: false,
            showBanner: false,
        };

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu(event) {
        const { currentTarget } = event;

        this.setState({
            anchorEl: currentTarget,
            menuOpen: !this.state.menuOpen
        });
    }

    componentDidUpdate() {
        if (this.state.showBanner) {
            AppContext.banner(null, true);
            this.setState({showBanner: false});
        }
    }

    render() {
        const { classes, title, restaurant, showMenu } = this.props;

        return (
            <AppBar position="static" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="title" color="inherit">
                        <img src="/images/logo.jpg" height="60" width="80" alt={`${this.props.t('Lukeloki') || 'Company'} logo`} />
                    </Typography>

                    <Typography variant="subheading" color="inherit"
                        style={{marginLeft: 10, textTransform: "uppercase"}}>
                        {this.props.t('Lukeloki')}
                    </Typography>

                    <Typography
                        variant="subheading"
                        color="inherit"
                        className={classes.appBarRestaurantTitle}>
                        { restaurant }
                    </Typography>
                    <Button onClick={() => changeLanguage('fi')} style={{ border: this.props.i18n.language === 'fi' ? '1px solid black' : '' }}>
                        Suomi
                    </Button>
                    <Button onClick={() => changeLanguage('en')} style={{ border: this.props.i18n.language === 'en' ? '1px solid black' : '' }}>
                        English
                    </Button>
                    <IconButton
                        onClick={() => this.setState({showBanner: true})}
                        color="default"
                        aria-label={this.props.t('Näytä ilmoitus')}
                    >
                        <NotificationsNoneRoundedIcon />
                    </IconButton>

                    <Button
                        style={{ display: showMenu ? 'flex' : 'none' }}
                        className={classes.menuButton}
                        onClick={this.toggleMenu}>
                        <Menu/>
                    </Button>
                </Toolbar>

                <Popper
                    open={this.state.menuOpen}
                    anchorEl={this.state.anchorEl}
                    placement="left"
                    className={classes.popper}>
                    <Paper
                        square={true}
                        onClick={() => this.setState({menuOpen: false})}>
                        <Nav/>
                    </Paper>
                </Popper>
            </AppBar>
        );
    }
}

export default withTranslation()(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./resources/assets/js/components/Header.js